<template>
  <div class="game-summary">
    <div class="blackBG-words"></div>
    <div class="modal">
      <div class="played-words" v-if="results">
        <div v-if="results" class="backBtn" @click="results = false">
          <inline-svg
            class="cup-svg saveWord"
            :src="require('../../assets/svg/back.svg').default"
          ></inline-svg>
        </div>
        <div>{{ $t("game-new.game-summery.improve") }}</div>
        <div class="divMistakes" :style="{ textAlign: ltr ? 'left' : 'right' }" >
          {{ $t("game-new.game-summery.mistakes") }}
        </div>
        <div class="word" v-for="(word, idx) in orderedPlayedItems" :key="idx">
          <div class="square" @click="saveWord(word)">
            <inline-svg
              class="cup-svg saveWord"
              :class="{ savedWord: isSaved(word) }"
              :src="
                isSaved(word)
                  ? require('../../assets/svg/saved.svg').default
                  : require('../../assets/svg/notsaved.svg').default
              "
            ></inline-svg>
          </div>
          <div class="audio"><AudioBtn :urlId="word.id" /></div>
          <div class="translations" ref="translations">
            <div class=" heb">{{ word.heb }}</div>
            <div class=" arbT arial">{{ word.Eng }}</div>
            <div class=" arb">{{ word.arb }}</div>
          </div>
          <div class="square" :class="{ squareWrong: word.wrong }">
            <!-- <inline-svg
              class="cup-svg mistakes"
              :src="require('../../assets/svg/wordsfull.svg').default"
            ></inline-svg> -->
            <span>{{ word.wrong || "-" }}</span>
          </div>
        </div>
      </div>
      <div v-if="!results">
        <div class="description">{{ outText }}</div>
        <Spacer height="12" v-if="audioSrc" />
        <AudioPlayer
          v-if="audioSrc"
          :audioSrc="audioSrc"
          :autoPlay="isAutoPlay"
        />
        <Spacer height="12" v-if="vidSrc" />
        <VideoPlayer1 :vidSrc="makeLinkEmbaddable(vidSrc)" v-if="vidSrc" />
        <Spacer height="12" v-if="imgSrc" />
        <img v-if="imgSrc" id="img" :src="imgSrc" />
        <Spacer height="12" />
      </div>
      <div class="flex btnsDiv" v-if="!results">
        <button class="btnSummry btnRestart" @click="restartGame">
          {{ $t("game-new.game-summery.again") }}
        </button>
        <button class="btnSummry btnRes" @click="results = true">
          {{ $t("game-new.game-summery.improve") }}
        </button>
      </div>
      <button v-if="!results" class="btnSummry btnGo" @click="goBack">
        {{ $t("game-new.game-summery.next") }}
      </button>
    </div>
  </div>
</template>

<script>
import "./game-summary.scss";
import AudioBtn from "../Shared/audioBtn.vue";
import { userService } from "../../services/userService";
import AudioPlayer from "../Shared/AudioPlayer.vue";
import VideoPlayer from "../Shared/VideoPlayer.vue";

import VideoPlayer1 from "../Shared/VideoPlayer.vue";
import Spacer from "../Shared/Spacer.vue";

export default {
  name: "game-summary",
  props: {
    playedItems: {
      type: Array,
      default: () => []
    },
    msg: {
      type: String,
      default: "עברו על המילים כדי להצליח בפעם הבאה"
    },
    currentData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      audioSrc: null,
      vidSrc: null,
      imgSrc: null,
      outText: null,
      allTranslationsHeight: [],
      text: "",
      results: false,
      isAutoPlay: true,
      ltr: localStorage.getItem("srcDirection") == "ltr",
    };
  },
  watch: {
    currentData() {
      if (this.currentData.game.outro_image)
        this.imgSrc = this.currentData.game.outro_image;
      if (this.currentData.game.outro_audio)
        this.audioSrc = this.currentData.game.outro_audio;
      if (this.currentData.game.outro_video)
        this.vidSrc = this.currentData.game.outro_video;
      if (this.currentData.game.outro_text)
        this.outText = this.currentData.game.outro_text;
    },
    results() {
      this.isAutoPlay = false;
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    savedWords() {
      if (this.user) {
        return this.user.saved_words.map(word => word.external_id);
      } else {
        return [];
      }
    },
    orderedPlayedItems() {
      return this.playedItems.sort((a, b) => {
        return (a.wrong || 0) > (b.wrong || 0) ? -1 : 1;
      });
    }
  },
  methods: {
    makeLinkEmbaddable: link => {
      if (String(link).includes("shorts")) {
        const youtubeID = String(link).split("/shorts/")[1];
        return (
          "https://www.youtube.com/embed/" +
          youtubeID +
          "?autoplay=0&fs=1&iv_load_policy=3&showinfo=0&controls=1&playsinline=1&rel=0&cc_load_policy=0&start=0&end=0"
        );
      }
      if (String(link).includes(".be/")) {
        const youtubeID = String(link).split(".be/")[1];
        return (
          "https://www.youtube.com/embed/" +
          youtubeID +
          "?autoplay=0&fs=1&iv_load_policy=3&showinfo=0&controls=1&playsinline=1&rel=0&cc_load_policy=0&start=0&end=0"
        );
      }
      const youtubeID = String(link).split("watch?v=")[1];
      return (
        "https://www.youtube.com/embed/" +
        youtubeID +
        "?autoplay=0&fs=1&iv_load_policy=3&showinfo=0&rel=0&cc_load_policy=0&start=0&end=0"
      );
    },
    isSaved(word) {
      if (word && this.savedWords.includes(word.id)) {
        return true;
      }
      return false;
    },
    restartGame() {
      this.$emit("restartGame");
    },
    async goBack() {
      // let thisLessonId = this.$store.getters.nextLesson.id
      // if (thisLessonId) {
      //   await userService.finishLesson(thisLessonId, this.user);
      // }

      this.$router.push("/chapter/");
    },
    goNext() {
      this.$router.push(`/lesson/${this.$store.getters.nextLesson.id}/`);
      // this.results = false;
    },
    saveWord(word) {
      if (!this.user) {
        // this.text = "עליך להתחבר על מנת לשמור מילים";
        this.text = this.$t("game-new.game-summery.msg1");
        return;
      }
      if (!this.isSaved(word)) {
        // this.text = `המילה ${word.heb}  נשמרה בהצלחה`;
        this.text = this.$t("game-new.game-summery.msg2") + `${word.heb}`;
        userService.saveWord(word.id);
      } else {
        this.text = this.$t("game-new.game-summery.msg3") + `${word.heb}`;
        userService.unsaveWord(word.id);
      }
    }
  },
  mounted() {
    if (this.$refs.line)
      this.allTranslationsHeight = this.$refs.line.map(el => {
        return el.clientHeight;
      });
    if (this.currentData.game.outro_image)
      this.imgSrc = this.currentData.game.outro_image;
    if (this.currentData.game.outro_audio)
      this.audioSrc = this.currentData.game.outro_audio;
    if (this.currentData.game.outro_video)
      this.vidSrc = this.currentData.game.outro_video;
    if (this.currentData.game.outro_text)
      this.outText = this.currentData.game.outro_text;
  },
  components: {
    AudioBtn,
    AudioPlayer,
    VideoPlayer,
    VideoPlayer1,
    Spacer
  }
};
</script>

<style scoped>
button {
  border: none;
}
.progress-icon {
  height: 24px;
}
.translations {
  font: var(--medium-font);
  display: flex;
  flex-direction: column;
  width: 55%;
  text-align: center;
}
.word {
  border-bottom: 1px solid var(--color-primary);
  display: flex;
  height: 74px;
  align-items: center;
}
.btn-remove {
  border: 0.5px solid var(--color-primary);
  font: var(--small-font);
  border-radius: 14px;
  padding: 4px;
  margin: 0 10px;
}
.idx {
  margin: 0 12px;
  width: 0.5em;
}
.audio {
  margin-right: 6px;
  width: 1em;
}
.played-words {
  margin-top: 20px;
  width: 100%;
}
.saveWord {
  fill: var(--button-primary-text);
}
.savedWord {
  fill: var(--saved-word);
}
.blackBG-words {
  background-color: var(--color-primary);
  opacity: 0.4;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
}

.modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  z-index: 11;
  background-color: var(--bg-primary);
  opacity: 1;
  padding: 12px;
  border-radius: 4px;
  max-width: 80vw;
  /* transform: translate(-12%, 0); */
  /* transform: translate(-50%, -50%); */
  position: absolute;
  top: 15%;
  /* left: unset; */
  /* right: 0; */
  /* transform: none; */
}
.backBtn {
  margin-bottom: 20px;
}
.btnSummry {
  border-radius: 6px;
  width: 100%;
  font: var(--medium-font);
}
.btnRestart {
  color: var(--button-primary-text);
  background-color: var(--button-primary);
}
.btnGo {
  color: var(--button-primary-text);
  background-color: var(--button-primary);
  margin-top: 8px;
  height: 60px;
}
.btnRes {
  color: var(--button-primary-text);
  background-color: var(--button-primary);
}
.btnsDiv {
  gap: 5px;
  width: 100%;
  height: 50px;
}
.divMistakes {
  font: var(--medium-font);
  text-align: left;
}
.square {
  color: var(--color-primary-ltr);
}
.squareWrong {
  color: var(--error-primary);
}
</style>



// WEBPACK FOOTER //
// game-summary.vue?5b032741